import { Component, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppConst } from '../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.css'],
  standalone: false,
})
export class ManualComponent implements OnInit {

  readonly index = AppConst.ROUTING_MANUAL_INDEX;
  // トップ画面
  readonly top = AppConst.ROUTING_MANUAL_TOP;
  readonly topDialog = AppConst.ROUTING_MANUAL_TOP_DIALOG;
  // プロジェクト情報
  readonly project = AppConst.ROUTING_MANUAL_PROJECT;
  readonly projectDialog = AppConst.ROUTING_MANUAL_PROJECT_DIALOG;
  // SPLATS情報
  readonly splats = AppConst.ROUTING_MANUAL_SPLATS;
  // ユーザー情報
  readonly user = AppConst.ROUTING_MANUAL_USER;
  readonly userDialog = AppConst.ROUTING_MANUAL_USER_DIALOG;
  // ファイルアップロード画面
  readonly uploader = AppConst.ROUTING_MANUAL_UPLOADER;
  // ファイルアップロード画面（プレゼント用）
  readonly uploaderDL = AppConst.ROUTING_MANUAL_UPLOADER_DL;
  // 施設情報
  readonly facility = AppConst.ROUTING_MANUAL_FACILITY;
  readonly facilityDialog = AppConst.ROUTING_MANUAL_FACILITY_DIALOG;
  // 施設属性情報
  readonly facilityAttribute = AppConst.ROUTING_MANUAL_FACILITY_ATTRIBUTE;
  readonly facilityAttributeDialog = AppConst.ROUTING_MANUAL_FACILITY_ATTRIBUTE_DIALOG;
  // 建物情報
  readonly hall = AppConst.ROUTING_MANUAL_HALL;
  readonly hallDialog = AppConst.ROUTING_MANUAL_HALL_DIALOG;
  // フロア情報
  readonly floor = AppConst.ROUTING_MANUAL_FLOOR;
  readonly floorDialog = AppConst.ROUTING_MANUAL_FLOOR_DIALOG;
  // 展示情報
  readonly exhibit = AppConst.ROUTING_MANUAL_EXHIBIT;
  readonly exhibitDialog = AppConst.ROUTING_MANUAL_EXHIBIT_DIALOG;
  readonly exhibitDetail = AppConst.ROUTING_MANUAL_EXHIBIT_DETAIL;
  readonly exhibitDetailDialog = AppConst.ROUTING_MANUAL_EXHIBIT_DETAIL_DIALOG;
  readonly exhibitRanking = AppConst.ROUTING_MANUAL_EXHIBIT_RANKING;
  // 展示属性情報
  readonly exhibitAttribute = AppConst.ROUTING_MANUAL_EXHIBIT_ATTRIBUTE;
  readonly exhibitAttributeDialog = AppConst.ROUTING_MANUAL_EXHIBIT_ATTRIBUTE_DIALOG;
  // 展示詳細属性情報
  readonly exhibitDetailAttribute = AppConst.ROUTING_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE;
  readonly exhibitDetailAttributeDialog = AppConst.ROUTING_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE_DIALOG;
  // 予約設備情報
  readonly reservationFacility = AppConst.ROUTING_MANUAL_RESERVATION_FACILITY;
  readonly reservationFacilityDialog = AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_DIALOG;
  // 設備予約状況：閲覧の説明
  readonly reservationFacilityReservation = AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_RESERVATION;
  // 予約設備：特別営業日
  readonly reservationFacilitySpecial = AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_SPECIAL;
  readonly reservationFacilitySpecialDialog = AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_SPECIAL_DIALOG;
  // 予約状況
  readonly reservation = AppConst.ROUTING_MANUAL_RESERVATION;
  readonly reservationDialog = AppConst.ROUTING_MANUAL_RESERVATION_DIALOG;
  readonly selectReservationDialog = AppConst.ROUTING_MANUAL_SELECT_RESERVATION_DIALOG;
  readonly confirmReservationDialog = AppConst.ROUTING_MANUAL_CONFIRM_RESERVATION_DIALOG;
  readonly confirmReservationDetailDialog = AppConst.ROUTING_MANUAL_CONFIRM_RESERVATION_DETAIL_DIALOG;
  // 予約状況
  readonly reservationQuestion = AppConst.ROUTING_MANUAL_RESERVATION_QUESTION;
  readonly reservationQuestionDialog = AppConst.ROUTING_MANUAL_RESERVATION_QUESTION_DIALOG;
  // 予約状況ダウンロード
  readonly reservationDownload = AppConst.ROUTING_MANUAL_RESERVATION_DOWNLOAD;
  // 予約状況ダウンロードファイル作成ダイアログ
  readonly reservationDownloadDialog = AppConst.ROUTING_MANUAL_RESERVATION_DOWNLOAD_DIALOG;
  // 予約設備属性情報
  readonly reservationFacilityAttribute = AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_ATTRIBUTE;
  readonly reservationFacilityAttributeDialog = AppConst.ROUTING_MANUAL_RESERVATION_FACILITY_ATTRIBUTE_DIALOG;
  // 通知情報
  readonly notice = AppConst.ROUTING_MANUAL_NOTICE;
  // 本番反映
  readonly reflectData = AppConst.ROUTING_MANUAL_REFLECT_DATA;
  // アプリ表示名ダイアログ
  readonly appnameDialog = AppConst.ROUTING_MANUAL_APPNAME_DIALOG;
  // 名称ダイアログ
  readonly nameDialog = AppConst.ROUTING_MANUAL_NAME_DIALOG;
  // 詳細ダイアログ
  readonly descDialog = AppConst.ROUTING_MANUAL_DESC_DIALOG;
  // 住所ダイアログ
  readonly addressDialog = AppConst.ROUTING_MANUAL_ADDRESS_DIALOG;
  // コピーライトダイアログ
  readonly copyrightDialog = AppConst.ROUTING_MANUAL_COPYRIGHT_DIALOG;
  // プライバシーポリシーダイアログ
  readonly policyDialog = AppConst.ROUTING_MANUAL_POLICY_DIALOG;
  // FAQダイアログ
  readonly faqDialog = AppConst.ROUTING_MANUAL_FAQ_DIALOG;
  // YouTubeダイアログ
  readonly youtubeDialog = AppConst.ROUTING_MANUAL_YOUTUBE_DIALOG;
  // 外部リンクURLダイアログ
  readonly urlDialog = AppConst.ROUTING_MANUAL_URL_DIALOG;
  // ユーザー入力タイトルダイアログ
  readonly userInputTitleDialog = AppConst.ROUTING_MANUAL_USER_INPUT_TITLE_DIALOG;
  // メール送信タイトルダイアログ
  readonly sendMailTitleDialog = AppConst.ROUTING_MANUAL_SEND_MAIL_TITLE_DIALOG;
  // メール送信本文ダイアログ
  readonly sendMailMessageDialog = AppConst.ROUTING_MANUAL_SEND_MAIL_MESSAGE_DIALOG;
  // QR(URL)生成ページ選択
  readonly qrcode = AppConst.ROUTING_MANUAL_QRCODE;
  // QRコード生成結果
  readonly qrcodeResult = AppConst.ROUTING_MANUAL_QRCODE_RESULT;
  // URL生成結果
  readonly urlResult = AppConst.ROUTING_MANUAL_URL_RESULT;
  // アンケート結果ダウンロード
  readonly enquete = AppConst.ROUTING_MANUAL_ENQUETE;
  // アンケート結果ダウンロードファイル作成ダイアログ
  readonly enqueteDialog = AppConst.ROUTING_MANUAL_ENQUETE_DIALOG;
  // 設問情報
  readonly question = AppConst.ROUTING_MANUAL_QUESTION;
  readonly questionDialog = AppConst.ROUTING_MANUAL_QUESTION_DIALOG;
  readonly questionSortDialog = AppConst.ROUTING_MANUAL_QUESTION_SORT_DIALOG;
  readonly qnameDialog = AppConst.ROUTING_MANUAL_QNAME_DIALOG;
  readonly qcompDialog = AppConst.ROUTING_MANUAL_QCOMP_DIALOG;
  readonly qitemDialog = AppConst.ROUTING_MANUAL_QITEM_DIALOG;
  // 設問セット
  readonly questSet = AppConst.ROUTING_MANUAL_QUEST_SET;
  readonly questSetDialog = AppConst.ROUTING_MANUAL_QUEST_SET_DIALOG;
  // 掲示板
  readonly boardThread = AppConst.ROUTING_MANUAL_BOARD_THREAD;
  readonly boardThreadDialog = AppConst.ROUTING_MANUAL_BOARD_THREAD_DIALOG;
  readonly boardComment = AppConst.ROUTING_MANUAL_BOARD_COMMENT;
  readonly boardCommentDialog = AppConst.ROUTING_MANUAL_BOARD_COMMENT_DIALOG;
  // 避難所情報
  readonly shelter = AppConst.ROUTING_MANUAL_SHELTER;
  readonly shelterDialog = AppConst.ROUTING_MANUAL_SHELTER_DIALOG;
  // 施設職員情報
  readonly facilityUser = AppConst.ROUTING_MANUAL_FACILITY_USER;
  readonly facilityUserDialog = AppConst.ROUTING_MANUAL_FACILITY_USER_DIALOG;
  // コンテンツ購入日次情報
  readonly purchaseContentDaily = AppConst.ROUTING_MANUAL_PURCHASE_CONTENT_DAILY;
  readonly selectPurchaseContentDailyDialog = AppConst.ROUTING_MANUAL_SELECT_PURCHASE_CONTENT_DAILY_DIALOG;
  // 入退場管理:イベント情報
  readonly entranceExitEvent = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_EVENT;
  // 入退場管理:イベント設問情報
  readonly entranceExitQuestion = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_QUESTION;
  readonly entranceExitQuestionDialog = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_QUESTION_DIALOG;
  // 入退場管理:スタッフ情報
  readonly entranceExitUser = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_USER;
  readonly entranceExitUserDialog = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_USER_DIALOG;
  // 入退場管理:エントリー情報
  readonly entranceExitEntry = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_ENTRY;
  readonly selectEntranceExitEntryDialog = AppConst.ROUTING_MANUAL_SELECT_ENTRANCE_EXIT_ENTRY_DIALOG;
  readonly entranceExitEntryDialog = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_ENTRY_DIALOG;
  readonly entranceExitTransitDialog = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DIALOG;
  // 入退場管理:日次入退場状況
  readonly entranceExitTransitDaily = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY;
  readonly selectEntranceExitTransitDailyDialog = AppConst.ROUTING_MANUAL_SELECT_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG;
  readonly entranceExitTransitDailyDialog = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_TRANSIT_DAILY_DIALOG;
  // 入退場管理:展示来場状況ダウンロード
  readonly entranceExitExhibitTransitDownload = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD;
  readonly entranceExitExhibitTransitDownloadDialog = AppConst.ROUTING_MANUAL_ENTRANCE_EXIT_EXHIBIT_TRANSIT_DOWNLOAD_DIALOG;
  // 音声ファイルダウンロード
  readonly voiceFileDownload = AppConst.ROUTING_MANUAL_VOICE_FILE_DOWNLOAD;

  page: string = '';
  currentLang: string = 'ja';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {
    // NOTE: コンポーネントの再利用を停止(ManualComponent内で各コンポーネントを表示させるため)
    this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
  }

  ngOnInit(): void {
    const page = this.route.snapshot.paramMap.get('page');
    this.page = page ? page : '';
    this.currentLang = this.translate.currentLang;
  }

}
